<template>
    <div>
        <button type="button"
            class="flex-none sm:rounded-full text-sm sm:text-base font-semibold sm:bg-blue-700 sm:hover:bg-blue-600 px-2 sm:px-6 py-1 sm:py-3 text-blue-400 sm:text-blue-100 hover:text-white"
            @click="openModal"
        >
            + {{ $t('New Property') }}
        </button>

        <transition
            enter-active-class="transition ease-out duration-100"
            enter-class="transform opacity-0"
            enter-to-class="transform opacity-100"
            leave-active-class="transition ease-in duration-100"
            leave-class="transform opacity-100"
            leave-to-class="transform opacity-0"
        >
            <div v-show="open"
                class="fixed top-0 left-0 flex items-center justify-center w-full h-full z-top"
                style="background-color: rgba(0, 0, 0, .45)"
            >
                <transition
                    enter-active-class="transition ease-out duration-150"
                    enter-class="transform scale-95"
                    enter-to-class="transform scale-100"
                >
                    <div v-show="open"
                        class="flex items-center justify-center w-full h-full overflow-auto"
                        @click.self="closeModal"
                    >
                        <div v-if="open"
                            @keydown.esc="closeModal"
                            class="relative h-auto p-4 m-2 bg-white rounded shadow-xl w-full md:max-w-lg md:p-6 lg:p-8 md:mx-0"
                        >
                            <div class="absolute p-3 text-2xl text-gray-400 hover:text-gray-600 right-0 top-0 cursor-pointer"
                                @click="closeModal"
                            >
                                <i class="far fa-times-circle"></i>
                            </div>

                            <div class="mb-0">
                                <h2 class="text-xl xs:text-3xl text-center pb-3 xs:pb-6">
                                    {{ $t('New Property') }}
                                </h2>

                                <div class="xs:px-10 mb-2 xs:mb-8">
                                    <input-text
                                        class="mb-3 xs:mb-5"
                                        input_class="text-sm sm:text-lg w-full"
                                        v-model="name"
                                        label="Client's Name"
                                        placeholder="Name"
                                        required="required"
                                        ref="name"
                                        :enter="submit"
                                    />

                                    <input-text
                                        class="mb-3 xs:mb-5"
                                        input_class="text-sm sm:text-lg w-full"
                                        v-model="email"
                                        label="Client's Email"
                                        placeholder="Email"
                                        required="required"
                                        :enter="submit"
                                    />

                                    <input-text
                                        v-if="has_mls_integration"
                                        class="mb-3 xs:mb-5"
                                        input_class="text-sm sm:text-lg w-full"
                                        v-model="mls_number"
                                        label="MLS #"
                                        placeholder="MLS #"
                                        :enter="submit"
                                        @change="fetchMlsData"
                                    />

                                    <input-text
                                        class="mb-3 xs:mb-5"
                                        input_class="text-sm sm:text-lg w-full"
                                        v-model="address"
                                        label="Property Address"
                                        placeholder="Address"
                                        required="required"
                                        :enter="submit"
                                    />

                                    <p class="font-semibold text-gray-warm-800 mt-1 mb-2">
                                        {{ $t('Is your client the buyer or the seller?') }}
                                    </p>

                                    <input-radio-boolean
                                        class="pb-2"
                                        name="our_purchase"
                                        true="Buyer"
                                        false="Seller"
                                        v-model="our_purchase"
                                    />

                                    <form-errors :errors="errors" />

                                    <div v-show="status === 'confirm-use-existing'" class="flex flex-1 items-center">
                                        <div class="text-blue-500 text-lg w-8">
                                            <i class="far fa-question-circle mr-1" aria-hidden="true"></i>
                                        </div>

                                        <p class="text-blue-500 leading-tight ml-1">
                                            A user with this email address already exists. <br class="hidden xs:block">Create a new property transaction for them?
                                        </p>
                                    </div>
                                </div>

                                <button type="button"
                                    v-show="status !== 'confirm-use-existing' && status !== 'success'"
                                    class="rounded-full block bg-green-warm-500 hover:bg-green-warm-400 text-white hover:text-white uppercase tracking-wider leading-none px-12 py-4 mx-auto"
                                    @click="submit()"
                                >
                                    {{ $t('Get Started') }}
                                </button>

                                <button type="button"
                                    v-show="status === 'confirm-use-existing' && status !== 'success'"
                                    class="rounded-full block bg-blue-500 hover:bg-blue-400 text-white hover:text-white tracking-wider leading-none px-12 py-4 mx-auto mb-1"
                                    @click="submit()"
                                >
                                    {{ $t('YES, Add a Property') }}
                                </button>

                                <div v-show="status === 'success'"
                                    class="mx-auto py-6 text-2xl text-blue-500 text-center"
                                >
                                    <i class="fas fa-spinner fa-spin"></i>
                                </div>

                                <p v-show="status !== 'confirm-use-existing' && status !== 'success'"
                                    class="text-sm leading-tight font-gray-400 text-center mt-4 xs:mt-8 -mb-2"
                                >
                                   {{ $t('Clicking \'Get Started\' will send an invitation to your Client') }} <br class="hidden xs:block">{{ $t('to start working on a new Property Profile with you.') }}
                                </p>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
import FormErrors from '../components/form-errors.vue';

export default {
    components: {
        FormErrors,
    },

    props: {
        has_mls_integration: {},
    },

    data() {
        return {
            name: '',
            email: '',
            address: '',
            mls_number: '',
            our_purchase: true,
            errors: [],
            open: false,
            status: null,
        }
    },

    methods: {
        openModal() {
            this.open = true;
            this.$nextTick(() => this.$refs.name.focus());
        },
        closeModal() {
            this.open = false;
            this.name = '';
            this.email = '';
            this.address = '';
            this.mls_number = '';
            this.our_purchase = true;
            this.errors = [];
            this.status = null;
        },
        submit() {
            if (this.status !== 'confirm-use-existing') {
                this.status = null;
            }

            axios({
                method: 'post',
                url: '/broker/properties',
                data: {
                    name: this.name,
                    email: this.email,
                    address: this.address,
                    mls_number: this.mls_number,
                    our_purchase: this.our_purchase,
                    use_existing: this.status === 'confirm-use-existing',
                }
            })
                .then(response => {
                    this.errors = [];
                    this.status = 'success';
                    window.location.href = '/broker/properties/' + response.data.property.id + '/dashboard/deal?section=home-office';
                }).catch(error => {
                    if (error.response.data.errors) {
                        this.status = 'error';
                        this.errors = Object.values(error.response.data.errors);
                    } else if (error.response.data.broker_exists) {
                        this.status = 'error';
                        this.errors = [['A broker with this email address already exists.']];
                    } else if (error.response.data.user_exists) {
                        this.status = 'confirm-use-existing';
                    }
                });
        },
        fetchMlsData(mls_number) {
            if (! mls_number) {
                return;
            }

            axios.get('/mls-lookup/' + mls_number)
                .then(response => {
                    if (response.data.data?.address) {
                        this.address = response.data.data.address;
                    }
                }).catch(error => {
                    console.log(error);
                });
        },
    },
}
</script>
